var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFoundIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25665",
    "data-name": "Group 25665",
    transform: "translate(-246.713 -484)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 55,
    cy: 55,
    r: 55,
    transform: "translate(246.713 484)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25665-2",
    "data-name": "Group 25665",
    transform: "translate(267.242 504.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37286",
    "data-name": "Path 37286",
    d: "M309.231,552.013A6.773,6.773,0,1,1,316,545.239,6.774,6.774,0,0,1,309.231,552.013Zm0-10.838a4.064,4.064,0,1,0,4.064,4.064A4.064,4.064,0,0,0,309.231,541.175Z",
    transform: "translate(-295.236 -531.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37287",
    "data-name": "Path 37287",
    d: "M314.7,530.278a1.354,1.354,0,0,1-1.355-1.353v-2.711a1.355,1.355,0,0,1,2.71,0v2.709a1.355,1.355,0,0,1-1.354,1.355Z",
    transform: "translate(-300.703 -524.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37288",
    "data-name": "Path 37288",
    d: "M329.9,537.657a1.355,1.355,0,0,1-.958-2.313l1.916-1.916a1.355,1.355,0,0,1,1.916,1.916l-1.916,1.916A1.351,1.351,0,0,1,329.9,537.657Z",
    transform: "translate(-308.337 -528.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37289",
    "data-name": "Path 37289",
    d: "M336.456,552.061h-2.709a1.355,1.355,0,1,1,0-2.71h2.709a1.355,1.355,0,1,1,0,2.71Z",
    transform: "translate(-310.269 -537.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37290",
    "data-name": "Path 37290",
    d: "M330.229,567.592a1.349,1.349,0,0,1-.958-.4l-1.916-1.916a1.355,1.355,0,0,1,1.916-1.916l1.916,1.916a1.355,1.355,0,0,1-.958,2.313Z",
    transform: "translate(-307.545 -544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37291",
    "data-name": "Path 37291",
    d: "M297.243,567.592a1.355,1.355,0,0,1-.958-2.313l1.916-1.916a1.355,1.355,0,0,1,1.916,1.916L298.2,567.2A1.349,1.349,0,0,1,297.243,567.592Z",
    transform: "translate(-291.937 -544.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37292",
    "data-name": "Path 37292",
    d: "M314.7,573.82a1.354,1.354,0,0,1-1.355-1.353v-2.711a1.355,1.355,0,0,1,2.71,0v2.71a1.355,1.355,0,0,1-1.354,1.355Z",
    transform: "translate(-300.703 -546.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37293",
    "data-name": "Path 37293",
    d: "M292.915,552.061h-2.71a1.355,1.355,0,1,1,0-2.71h2.71a1.355,1.355,0,0,1,0,2.71Z",
    transform: "translate(-288.403 -537.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37294",
    "data-name": "Path 37294",
    d: "M297.573,537.657a1.348,1.348,0,0,1-.958-.4l-1.916-1.916a1.355,1.355,0,0,1,1.916-1.916l1.916,1.916a1.355,1.355,0,0,1-.958,2.313Z",
    transform: "translate(-291.145 -528.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37295",
    "data-name": "Path 37295",
    d: "M358.236,593.39l-28.45-54.176c.014-.013,0-.013,0-.013a2.585,2.585,0,0,0-.217-.312,2.487,2.487,0,0,0-.3-.23,1.27,1.27,0,0,0-.312-.136,1.391,1.391,0,0,0-.745,0,1.283,1.283,0,0,0-.312.136,2.524,2.524,0,0,0-.3.23,1.577,1.577,0,0,0-.217.312v.013l-15.255,29.059-4.024-7.424c0-.013-.013-.013-.027-.027a1.02,1.02,0,0,0-.2-.271,1.265,1.265,0,0,0-.271-.2.709.709,0,0,0-.176-.1,1.066,1.066,0,0,0-.19-.068,1.319,1.319,0,0,0-.65,0,.793.793,0,0,0-.189.068.417.417,0,0,0-.136.054,1.307,1.307,0,0,0-.542.542l-17.612,32.513a1.358,1.358,0,0,0,2.384,1.3l16.419-30.319,4.01,7.411.081.149,12.328,22.759a1.358,1.358,0,0,0,2.384-1.3l-12.044-22.231,4.213-8.02,4.769,4.769a1.374,1.374,0,0,0,1.924,0l4.457-4.457,4.457,4.457a1.374,1.374,0,0,0,1.924,0l4.173-4.173,16.243,30.929a1.347,1.347,0,0,0,1.206.731,1.5,1.5,0,0,0,.623-.149,1.354,1.354,0,0,0,.57-1.827Zm-23.776-28.4L330,560.538a1.365,1.365,0,0,0-1.924,0l-4.457,4.457-4.4-4.4,9.374-17.856,9.686,18.438Z",
    transform: "translate(-287.952 -531.695)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIcon);
export default __webpack_public_path__ + "static/media/not-found-icon.590781069be990dd78e4a4f6d37eb90d.svg";
export { ForwardRef as ReactComponent };